import './style.scss';
import { ResponseHomeNewsDetail } from 'common-modules/general/API/news/types';
import { toJS } from 'mobx';

interface Props {
  data: ResponseHomeNewsDetail;
}

const PageContent = ({ data }: Props) => {
  const htmlData = toJS(data.cntNtcPlteWhol);

  return (
    <div className="page-content_container">
      <div className="detail-view">
        <div className="subject-area">
          <div className="h-title-area">
            <h2 className="h-title medium03">{data.sbjtNtcPlte}</h2>
            <span className="date">{data.dntRgst}</span>
          </div>
        </div>
        <div className="txt-area">
          <div dangerouslySetInnerHTML={{ __html: htmlData }}></div>
        </div>
      </div>
    </div>
  );
};

export default PageContent;
